module.exports = __webpack_public_path__ + "img/logo-menu-hover.3c5bbc65.png";